import React from 'react'
import SugarDaddyTop from '../sugarDaddyTop/SugarDaddyTop'
import SugarDaddyReview from '../sugarDaddyReview/SugarDaddyReview'
import SugarDaddyFollow from '../sugarDaddyFollow/SugarDaddyFollow'

const SugarDaddy = () => {
  return (
    <div className='dashboard-content-box dashboard-profile'>
        <div className='top-sugar-daddy-box'>
            <SugarDaddyTop />
        </div>
        <div className='sugar-daddy-reviews-sec'>
          <SugarDaddyReview />
        </div>
        <div className='sugar-daddy-bottom-follow-sec'>
            <SugarDaddyFollow />
        </div>
    </div>
  )
}

export default SugarDaddy